export enum PaymentReportColumnsEnum {
  AccountNumber = 'AccountNumber',
  AccountType = 'AccountType',
  Status = 'Status',
  ReferenceNumber = 'ReferenceNumber',
  Date = 'Date',
  Direction = 'Direction',
  TypeOfTransfer = 'TypeOfTransfer',
  Description = 'Description',
  SenderIban = 'SenderIban',
  BeneficiaryIban = 'BeneficiaryIban',
  Currency = 'Currency',
  ExchangeRate = 'ExchangeRate',
  SenderAmount = 'SenderAmount',
  BeneficiaryAmount = 'BeneficiaryAmount',
  TotalAmount = 'TotalAmount',
  Fee = 'Fee',
}
